import throttle from "lodash.throttle";
import { useLayoutEffect } from "react";
import { useContainer } from "./useContainer.mjs";
import { useEditor } from "./useEditor.mjs";
function useScreenBounds() {
  const editor = useEditor();
  const container = useContainer();
  useLayoutEffect(() => {
    const updateBounds = throttle(
      () => {
        editor.updateViewportScreenBounds();
      },
      200,
      { trailing: true }
    );
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0].contentRect) {
        updateBounds();
      }
    });
    if (container) {
      resizeObserver.observe(container);
    }
    updateBounds();
    return () => {
      resizeObserver.disconnect();
    };
  }, [editor, container]);
}
export {
  useScreenBounds
};
//# sourceMappingURL=useScreenBounds.mjs.map
